import 'swiper/css';
import 'swiper/css/navigation';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import cookieEnum from '../../enums/cookieEnum';
import { setLoading } from '../../services/reducers/homeSlice';
import { profile } from '../../services/reducers/userSlice';
import restApi from '../../services/restApi';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.login).post({
      phoneNumber: username,
      password: password
    });

    dispatch(setLoading(false));

    if (res.code == 200){
      Cookies.set('token', res.data.token);
      dispatch(profile(res.data))
      if (res.data.role === "SUPER_ADMIN"){
        navigate('/analytics');
      } else {
        navigate('/order/');
      }
    }else{
      Swal.fire({
        title: 'ناموفق',
        text: 'نام کاربری یا رمز عبور صحیح نمی باشد',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }
  };

  useEffect(() => {
    if (Cookies.get('token')){
      navigate('/')
    }
  }, []);

  return (
    <section className="loginPage">
      <div className="loginImageContainer">
        <img src="/img/newPhotos/WB-67.jpg" className="loginImage" alt=""/>
        <div className="loginImageOverlay"/>
        <div className="loginImageCaption">
          <span>پنل B2B بلبرینگ و کاسه‌نمد ODM</span>
          <small>ODM BEARINGS</small>
        </div>
      </div>
      <div className="LoginInfoSection">
        <div className="loginheader">
          <img src="/img/odm-logo.png" className="loginLogo" alt="ODM"/>
          <h1 className="loginTextName">پنل مدیریت B2B</h1>
        </div>
        <div className="loginBoxSection">
          <label className="loginInfo" htmlFor="username">شماره تلفن</label>
          <input className="inputBox" id="username" onChange={(input: any) => setUsername(input.target.value)} />
          <label className="loginInfo marginTop" htmlFor="password">رمز ورود</label>
          <input className="inputBox" type="password" onChange={(input: any) => setPassword(input.target.value)} id="password"/>
          <span className="loginButtom" onClick={send}>ورود</span>
        </div>
        <div className="loginFooter">© ODM — بلبرینگ و کاسه نمد خودرو</div>
      </div>
    </section>
  );
};
export default Login;